export default __webpack_public_path__ + "static/demo-image-02-75d646b926c5d069952b228c63a0f575.jpg";